import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ValidationService } from '@core/services/validation.service';
import {error} from "protractor";

@Component({
  selector: 'field-control-error-messages',
  templateUrl: './field-control-error-messages.component.html',
  styleUrls: ['./field-control-error-messages.component.scss']
})
export class FieldControlErrorMessagesComponent {

  @Input() control: FormControl;
  @Input() placeholder: string;

  constructor(
    private validationService: ValidationService
  ) { }

  get errorMessage() {
    if (this.control) {
      for (let propertyName in this.control.errors) {
        if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
          return this.validationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName], this.getElementPlaceholder());
        }
      }
    }

    return null;
  }

  getElementPlaceholder() {
    return (this.placeholder) ? this.placeholder.replace(/[&\/\\#+()$~%.'":*?<>{}]/g, '') : null;
  }


  }

